import axios from "axios";
import store from "@/store";
import Cookies from "js-cookie";
import router from "./../router";
import { Message } from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

import { POR_LOGIN_LOGOUT } from "./config";

export const requestData = (methods, url, datas, headers, timeout) => {
  //封装请求方法
  let headerObj = {};
  // localStorage.getItem("locale") ||
  headerObj = {
    "Content-Type": "application/json",
    Authorization: "Basic c2FiZXI6c2FiZXJfc2VjcmV0",
    applet: "3",
    i18n: "zh",
    "blade-auth": store.state.token ? "bearer " + store.state.token : "",
  };

  if (!datas) datas = {};

  let options = Object.assign(
    {},
    {
      url: url,
      method: methods,
      baseURL: POR_LOGIN_LOGOUT, // config 的 base_url
      timeout: 1 * 60 * 1000, // 超时
      headers: Object.assign(headers || {}, headerObj),
    }
  );
  if (methods == "get") {
    options.params = datas;
  } else if (methods == "post") {
    options.data = datas;
  } else if (methods == "put") {
    options.params = datas;
  } else if (methods == "delete") {
    options.params = datas;
  }
  if (headers) {
    options.headers = headers;
  }
  if (timeout) {
    options.timeout = timeout;
  }

  let listPromise = new Promise((resolve, reject) => {
    axios
      .request(options)
      .then((res) => {
        resolve(res.data);
      })
      .catch((res) => {
        reject(res);
      });
  });
  return listPromise;
};

axios.interceptors.request.use(
  //请求拦截
  (config) => {
    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);

axios.interceptors.response.use(
  function (res) {
    if (res.data.code == 401) {
      loginFunc();
    } else if (res.data.code == 601 || res.data.code == 602) {
      if (
        store.state.user.certifiedAccountOpeningStatus == 0 ||
        store.state.user.certifiedAccountOpeningStatus == 2 ||
        store.state.user.certifiedAccountOpeningStatus == 7
      ) {
        router.push("/userAuth");
        // Message({
        //   message: "暂不支持该操作，请稍后～",
        //   type: "error",
        //   center: true
        // });
      } else if (store.state.user.certifiedAccountOpeningStatus == 1) {
        Message({
          message: "开户协议签署中，请稍后～",
          type: "error",
          center: true,
        });
      } else if (store.state.user.certifiedAccountOpeningStatus == 4) {
        Message({
          message: "企业信息登记中，请稍后～",
          type: "error",
          center: true,
        });
      }
    } else if (res.data.code == 500) {
      Message({
        message: res.data.message || "服务报错了，请联系管理员",
        type: "error",
        center: true,
      });
    }
    return res;
  },
  function (error) {
    if (error.response.status == 401) {
      loginFunc();
    }
  }
);
const loginFunc = () => {
  Message.closeAll();
  Message({
    message: "登录过期,请重新登录...",
    type: "error",
    center: true,
    onClose: function () {
      // Cookies.remove("userInfo");
      store.commit("quitLogin");
      router.replace({
        path: "/login?type=3",
      });
    },
  });
};



// WEBPACK FOOTER //
// ./src/request/request.js